<template>
    <div class="d-flex flex-column justify-space-between fill-height" :style="cssVars">
        <div>
            <v-list
                v-for="(item, index) in menu"
                :key="index"
                class="main-navigation"
                nav
            >
                <div v-if="!item.submenu">
                    <v-list-item :to="item.route" class="nav-item" active-class="bg-active" link>
                        <v-list-item-action class="nav-icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-title class="nav-content">
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item>
                </div>
                <div v-if="item.submenu && canShow(ruleSet.menu)"
                     :class="{'sub-navigation': isSelected(item)}">
                    <v-list-group :value="true">
                        <template #activator>
                            <v-list-item class="sub-nav-item">
                                <v-list-item-action class="nav-icon">
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title class="nav-content">
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <v-list-item
                            v-for="(child, index2) in item.submenu"
                            :key="index2"
                            :to="child.route"
                            class="sub-item"
                            link
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ child.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </div>
            </v-list>
        </div>
        <v-btn v-if="isAdminPu"
               class="ma-4"
               icon
               large
               @click="showDialog = true"
        >
            <v-icon>
                mdi-qrcode
            </v-icon>
        </v-btn>
        <qrcode :visible="showDialog"
                @close="showDialog = false"></qrcode>
    </div>
</template>


<script>
import roles from "../mixins/roles";
import qrcode from '../components/dialogs/qrcode';
import Config from "../../js/config.singleton";

export default {
    name: "Navigation",
    components: {qrcode},
    mixins: [roles],
    data() {
        return {
            showDialog: false,
        };
    },
    computed: {
        cssVars() {
            return {
                '--bg-color': Config.secondary_color ?? '#fbd72b',
            }
        },
        menu() {
            return [
                {
                    text: this.$t('menu.tracking_tours'),
                    code: "tracking_tours",
                    icon: "mdi-map-marker-path",
                    route: "/app/tours"
                },
                {
                    text: this.$t('menu.referentiels'),
                    icon: "mdi-file-excel",
                    submenu: [
                        {
                            text: this.$t('menu.users'),
                            code: "users",
                            route: "/app/users"
                        },
                        {
                            text: Config.driver_label ?? this.$t('menu.drivers'),
                            code: "drivers",
                            route: "/app/drivers"
                        },
                        {
                            text: this.$t('menu.customers'),
                            code: "customers",
                            route: "/app/customers"
                        },
                        /*{
                            text: this.$t('menu.sites'),
                            code: "sites",
                            route: "/app/sites"
                        },
                        {
                            text: this.$t('menu.tours_types'),
                            code: "tours_types",
                            route: "/app/tours_types"
                        },*/
                        {
                            text: this.$t('menu.tours_models'),
                            code: "tours_models",
                            route: "/app/tours_models"
                        }
                    ]
                },
                {
                    text: this.$t('menu.administration'),
                    code: "administration",
                    icon: "mdi-settings",
                    route: "/app/administration"
                },
                /*{
                    text: this.$t('menu.messaging'),
                    code: "messaging",
                    icon: "mdi-message-reply-text",
                    route: "/app/Messaging"
                },*/
                {
                    text: this.$t("menu.monitoring"),
                    code: "monitoring",
                    icon: "mdi-devices",
                    route: "/app/monitoring"
                }
            ]
        }
    },
    methods: {
        isSelected(item) {
            return (item?.route === this.$route.path) || !!(item?.submenu || []).find(o => this.isSelected(o))
        },
    },
};
</script>

<style lang="scss">

    .v-navigation-drawer {
        .main-navigation {
            .nav-item {
                &.v-list-item--active {
                    background-color: var(--bg-color);
                }
            }
        }

        .sub-navigation {
            .v-list-group__header {
                &.v-list-item--active {
                    background-color: var(--bg-color);
                }
            }
        }
    }

</style>
